import { Ticket, Gift, Wallet, ListChecks, Search, History, ChevronRight, ShoppingBag } from "lucide-react";

function Tile({ icon: Icon, title, sub, onClick, testid, tone }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className="group w-full flex items-center gap-3 p-3.5 rounded-2xl bg-white border border-slate-100 shadow-sm hover:border-[#1e3a5f] hover:shadow-md transition-[border-color,box-shadow] text-left">
      <span className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${tone}`}><Icon className="w-5 h-5" /></span>
      <span className="flex-1 min-w-0">
        <span className="block font-bold text-[#1e3a5f] text-sm">{title}</span>
        <span className="block text-xs text-slate-500 truncate">{sub}</span>
      </span>
      <ChevronRight className="w-4 h-4 text-slate-300 group-hover:translate-x-0.5 transition-transform" />
    </button>
  );
}

function Group({ id, title, children }) {
  return (
    <section id={id} className="mb-5 scroll-mt-4" data-testid={id}>
      <h3 className="text-[11px] font-bold uppercase tracking-widest text-slate-400 mb-2">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">{children}</div>
    </section>
  );
}

const rate = (r) => (r && Number(r.value) > 0 ? ` · card +${r.type === "percent" ? `${r.value}%` : `€${Number(r.value).toFixed(2)}`}` : "");

export default function DeskTiles({ event, posRule, go }) {
  const canSell = event.status === "active" && event.settlement_status !== "settled";
  const canTickets = event.settlement_status !== "settled";
  return (
    <>
      {canSell ? (
        <Group id="desk-sell" title="Sell">
          <Tile icon={Ticket} title="Walk-in Ticket" sub={`Sold & checked in at the door${rate(posRule)}`} onClick={() => go("walkin")} testid="walkin-sale-btn" tone="bg-[#1e3a5f]/10 text-[#1e3a5f]" />
          <Tile icon={Gift} title="Coupon" sub={`Event credit for stalls${rate(posRule)}`} onClick={() => go("sellCoupon")} testid="sell-coupon-btn" tone="bg-[#1e3a5f]/10 text-[#1e3a5f]" />
          <Tile icon={ShoppingBag} title="Sell Items" sub={`Event desk sale · cash, card, wallet${rate(posRule)}`} onClick={() => go("deskSale")} testid="desk-sale-btn" tone="bg-[#1e3a5f]/10 text-[#1e3a5f]" />
          <Tile icon={Wallet} title="Wallet Top-up" sub={`Find a member/guest wallet${rate(posRule)}`} onClick={() => go("topupSearch")} testid="desk-topup-btn" tone="bg-[#1e3a5f]/10 text-[#1e3a5f]" />
        </Group>
      ) : (
        <p className="text-xs text-slate-500 bg-slate-100 rounded-xl px-3 py-2 mb-5" data-testid="desk-sell-closed">
          {event.settlement_status === "settled" ? "Event settled — sales are closed." : event.status === "completed" ? "Event ended — sales are closed. Ticket and coupon lookups stay open until the FA settles." : "Sales open while the event is active."}
        </p>
      )}
      <Group id="desk-lookup" title="Look up">
        {canTickets && <Tile icon={ListChecks} title="Tickets" sub="Search, filter, check-in list" onClick={() => go("tickets")} testid="open-tickets-btn" tone="bg-amber-100 text-amber-700" />}
        <Tile icon={Search} title="Coupons" sub="Find, reprint QR / PDF, email" onClick={() => go("couponLookup")} testid="find-coupon-btn" tone="bg-amber-100 text-amber-700" />
        <Tile icon={History} title="Recent sales" sub="Walk-ins, coupons, top-ups, desk sales" onClick={() => go("activity")} testid="desk-activity-btn" tone="bg-amber-100 text-amber-700" />
      </Group>
    </>
  );
}
